import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../ab_testing/ongoing_ab_tests";

const visiblePriceAbTestInstance = abTestingInstance.getABTestContainerProps(OngoingABTests.VISIBLE_PRICE_AB);

export function useVisiblePriceAbTest() {
    const {abTestVariant: visiblePriceVariant} = useABTest(visiblePriceAbTestInstance);

    return visiblePriceVariant;
}
import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../ab_testing/ab_testing_instance";
import {OngoingABTests} from "../ab_testing/ongoing_ab_tests";

const visiblePriceAbTestInstance = abTestingInstance.getABTestContainerProps(OngoingABTests.VISIBLE_PRICE_AB);

export function useVisiblePriceAbTest() {
    const {abTestVariant: visiblePriceVariant} = useABTest(visiblePriceAbTestInstance);

    return visiblePriceVariant;
}
